import React from 'react';
import _ from 'lodash';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { format } from '../../../../../../common/services/common.service';

export const BusinessUsersDetailsInfoComponent = ({ businessDetails }: any) => {
    return (
        <>
            <AccordionContainer
                child={
                    <div className="h-auto w-full bg-white p-2 rounded overflow-y-auto">
                        <table className="w-full text-xs bg-red-50">
                            <thead className="w-full border-y border-black border-opacity-20">
                                <tr className="w-full text-left h-12">
                                    <th className="px-3">S.NO</th>
                                    <th className="px-3">Business Name</th>
                                    <th className="px-3">Email</th>
                                     <th className="px-3">Phone Number</th>
                                    <th className="px-3">First Name</th>
                                    <th className="px-3">Last Name</th>
                                    <th className="px-3">CreatedOnUtc</th>
                                    <th className="px-3">ModifiedOnUtc</th>
                                </tr>
                            </thead>
                            <tbody className="w-full h-auto">
                                {businessDetails?.BusinessUsers?.map((ProductsItems: any, index: any) => (
                                    <tr key={index} className="cursor-pointer h-16 even:bg-[#F8F9FAFF] odd:bg-white">
                                        <td className="px-3">{index + 1}</td>
                                        <td className="px-3">{ProductsItems?.BusinessName}</td>
                                        <td className="px-3">{ProductsItems?.Email}</td>
                                        <td className="px-3">{ProductsItems?.PhoneNumber}</td>
                                        <td className="px-3">{ProductsItems?.FirstName}</td>
                                        <td className="px-3">{ProductsItems?.LastName}</td>
                                        <td className="px-3">{format(ProductsItems?.CreatedOnUtc)}</td>
                                        <td className="px-3">{format(ProductsItems?.ModifiedOnUtc)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                }
                expandedPanel="BusinessUser Info"
                headerTitle="BusinessUser Info"

            />

        </>
    )
}
export default BusinessUsersDetailsInfoComponent;